import { useEffect, useRef } from "react";
import { usePrefersReducedMotion } from "../hooks/usePrefersReducedMotion";

export function CustomCursor() {
  const dotRef = useRef<HTMLDivElement>(null);
  const ringRef = useRef<HTMLDivElement>(null);
  const prefersReduced = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReduced) return;
    if (!window.matchMedia("(pointer: fine)").matches) return;

    let mouseX = -100;
    let mouseY = -100;
    let ringX = -100;
    let ringY = -100;
    let rafId: number;

    document.body.style.cursor = "none";

    const onMouseMove = (e: MouseEvent) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
    };

    const onMouseOver = (e: MouseEvent) => {
      if ((e.target as Element).closest("a, button, [role='button'], [tabindex]")) {
        ringRef.current?.setAttribute("data-hover", "true");
      }
    };

    const onMouseOut = (e: MouseEvent) => {
      if ((e.target as Element).closest("a, button, [role='button'], [tabindex]")) {
        ringRef.current?.removeAttribute("data-hover");
      }
    };

    const tick = () => {
      ringX += (mouseX - ringX) * 0.15;
      ringY += (mouseY - ringY) * 0.15;

      dotRef.current?.style.setProperty("transform", `translate(${mouseX}px,${mouseY}px) translate(-50%,-50%)`);
      ringRef.current?.style.setProperty("transform", `translate(${ringX}px,${ringY}px) translate(-50%,-50%)`);

      rafId = requestAnimationFrame(tick);
    };

    window.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseover", onMouseOver);
    document.addEventListener("mouseout", onMouseOut);
    rafId = requestAnimationFrame(tick);

    return () => {
      document.body.style.cursor = "";
      window.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseover", onMouseOver);
      document.removeEventListener("mouseout", onMouseOut);
      cancelAnimationFrame(rafId);
    };
  }, [prefersReduced]);

  if (prefersReduced) return null;

  return (
    <>
      <div
        ref={dotRef}
        aria-hidden="true"
        className="fixed top-0 left-0 z-[99999] w-2 h-2 rounded-full bg-teal-400 pointer-events-none will-change-transform"
      />
      <div
        ref={ringRef}
        aria-hidden="true"
        className="fixed top-0 left-0 z-[99998] w-9 h-9 rounded-full border border-teal-400/40 pointer-events-none will-change-transform transition-[width,height,border-color,opacity] duration-150 data-[hover]:w-12 data-[hover]:h-12 data-[hover]:border-teal-400/80"
      />
    </>
  );
}
